import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const AboutSection = styled.section`
  padding: 5rem 2rem;
  background: #f8f9fa;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ImageWrapper = styled(motion.div)`
  img {
    width: 100%;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
`;

const Content = styled.div`
  h2 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #666;
    margin-bottom: 2rem;
  }
`;

const Education = styled.div`
  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  li {
    margin-bottom: 0.5rem;
    font-size: 1.1rem;
    color: #444;
  }
`;

const About = () => {
  return (
    <AboutSection id="about">
      <Container>
        <ImageWrapper
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <img src={`${process.env.PUBLIC_URL}/images/myface.png`} alt="Profile" />
        </ImageWrapper>
        <Content>
          <h2>About Me</h2>
          <p>
            Currently pursuing Computer Science and Engineering at Dong-A University. I'm passionate about 
            Generative AI, and creating innovative solutions that bridge the gap between 
            technology and real-world applications.
          </p>
          <Education>
            <h3>Education</h3>
            <ul>
              <li>Dong-A University, Computer Science and Engineering (Mar 2020 - Feb 2026)</li>
            </ul>
          </Education>
        </Content>
      </Container>
    </AboutSection>
  );
};

export default About;
